import React from 'react'

export interface FlipperAvatarProps {
  size?: 'xs' | 's' | 'm' | 'l'
  className?: string
}

const sizeMap = { xs: 24, s: 32, m: 40, l: 50 }

export const FlipperAvatar: React.FC<FlipperAvatarProps> = ({
  size = 's',
  className = ''
}) => {
  const px = sizeMap[size]
  return (
    <span
      className={`inline-block shrink-0 rounded-full overflow-hidden ${className}`}
      style={{ width: px, height: px }}
      title='Flipper (AI Assistant)'>
      <svg
        width={px}
        height={px}
        viewBox='0 0 102 102'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='block'>
        <g filter='url(#flipper_filter)'>
          <rect
            x='24'
            y='16'
            width='54'
            height='54'
            rx='27'
            fill='#F9A8D4'
            shapeRendering='crispEdges'
          />
          <path
            d='M39.9453 43C39.9453 43 42.8838 48.5229 50.991 48.5229C59.0981 48.5229 62.0366 43 62.0366 43'
            stroke='black'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M42.7067 40.2388C42.8845 40.0037 43.1038 39.7831 43.3243 39.5805C45.375 37.7417 48.255 36.9717 50.991 36.9773C50.9912 36.9773 50.9914 36.9773 50.9916 36.9773C53.7273 36.9717 56.6073 37.7414 58.6577 39.5804C58.8781 39.7831 59.0973 40.0036 59.2751 40.2388C59.0497 40.0504 58.7947 39.8831 58.5441 39.7327C56.2318 38.3883 53.5878 37.9846 50.9916 37.9773C50.9914 37.9773 50.9912 37.9773 50.991 37.9773C48.3946 37.9847 45.7504 38.3887 43.4378 39.7329C43.1871 39.8832 42.9322 40.0505 42.7067 40.2388Z'
            fill='#FBCFE8'
          />
          <path
            d='M35.343 37.4771H35.3609'
            stroke='black'
            strokeWidth='3'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M66.6389 37.4771H66.6568'
            stroke='black'
            strokeWidth='3'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <filter
            id='flipper_filter'
            x='0'
            y='0'
            width='102'
            height='102'
            filterUnits='userSpaceOnUse'
            colorInterpolationFilters='sRGB'>
            <feFlood floodOpacity='0' result='BackgroundImageFix' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='8' />
            <feGaussianBlur stdDeviation='12' />
            <feComposite in2='hardAlpha' operator='out' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.290196 0 0 0 0 0.396078 0 0 0 0 0.447059 0 0 0 0.16 0'
            />
            <feBlend
              mode='normal'
              in2='BackgroundImageFix'
              result='effect1_dropShadow_300_31131'
            />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='effect1_dropShadow_300_31131'
              result='shape'
            />
          </filter>
        </defs>
      </svg>
    </span>
  )
}

export default FlipperAvatar
